<template>
  <div class="error-msg-modal">
    <el-dialog
      title="错误信息"
      :visible.sync="visible"
      width="600px"
      append-to-body
      class="error-msg"
      :close-on-click-modal="false"
    >
      <div class="error-content">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="error-text" v-html="errorMsg"></div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ErrorMsgModal',
  data() {
    return {
      visible: false,
      errorMsg: '',
    }
  },
  methods: {
    show(msg) {
      this.errorMsg = ''
      this.errorMsg = msg
      this.visible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.error-msg {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
  .error-content {
    .error-text {
      max-height: 300px;
      overflow-y: auto;
      padding: 12px;
      background: #fdf6ec;
      border-radius: 4px;
      font-size: 13px;
      line-height: 22px;
      color: #e6a23c;
      word-break: break-all;
    }
  }
  .dialog-footer {
    ::v-deep .el-button {
      min-width: 90px;
    }
  }
}
</style>
